// extracted by mini-css-extract-plugin
export default {"FooterButtonsLayout":"FooterButtonsLayout-module-dbd33e418b8c8cdcd07e"};